module.exports = __webpack_public_path__ + "bb4ecffa8c8fc3933332894202233d4b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/Yummy/images/backgrounds/8.png
// module id = 38
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18